import store from "../../../../../store";

import lodash from "lodash";
import { conditionFormChecker, putField } from "../../../../../utils/form";
import { defineAsyncComponent } from "vue";
import i18n from "../../../../../i18n";
import { Divider } from "ant-design-vue";
import {
    createFieldCheckbox,
    createFieldDate,
    createFieldInput,
    createFieldRadioGroup,
    createFieldSelect,
    createFieldTemplateBuilder,
    createFieldTextArea,
    createFieldTreeSelect
} from "../../../../../components/input/template-builder/template-builder.logic";
import {
    callAnalyticalMethod,
    callHazDetailSubStanceType,
    callHazObject,
    callHazType,
    callHazProductUse,
    callHazSubStanceType,
    clearSubStanceMain
} from "../../../haz/request/haz-info/haz-info.section";
import { filter } from "../../../../../utils/search";
import { callCustoms, callTransportObjective } from "../../../inform/request/inform-info/inform-info.section";
import { callTransportByWay } from "../../../inform/request/inform-info/inform-info.section";

import moment from "moment";

export const callDepartment = () => store.dispatch("resource/v1/master/department/cacheFindAllWithChildrenType", { type: "main" });

export const callCountry = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/country/cacheFindAll", {
        where: [
            { name: "nameTh", type: "String", operator: "like", value: searchQuery },
            { logic: "OR", name: "nameEn", type: "String", operator: "like", value: searchQuery }
        ],
        sort: [{ name: "seq", type: "ASC" }]
    });

export const callAllFreeSale = ({ searchQuery, refUserCompanyId, notIn /*, checkExpireDate*/ }) => {
    const where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "refStatus.key", type: "String", isNot: "true", operator: "in", value: ["cancel", "suspend"] },
        { openBucket: true, name: "refStatus.key", type: "String", operator: "=", value: "complete" },
        { logic: "OR", closeBucket: true, name: "expireDate", type: "Date", operator: ">=", value: moment().format("YYYY-MM-DD") }
    ];
    if (notIn?.length > 0) {
        where.push({ name: "id", type: "UUID", operator: "!in", value: notIn });
    }
    // if (checkExpireDate) {
    //     where.push({ name: "expireDate", type: "Date", operator: ">=", value: moment().format("YYYY-MM-DD") })
    // }
    if (refUserCompanyId) {
        where.push({ name: "refUserCompany.id", type: "UUID", operator: "=", value: refUserCompanyId });
    }
    if (searchQuery) {
        where.push({ name: "approveCode", type: "String", operator: "like", value: searchQuery });
    }
    return store
        .dispatch("resource/v1/transaction/freeSale/search", {
            criteria: {
                isDistinct: true,
                select: ["**", "refHaz.*", "refInform.*"],
                page: 0,
                size: 1000000,
                where,
                sort: [{ name: "approveCode", type: "DESC" }]
            }
        })
        .then(page => page.data);
};

export const callHaz = ({ searchQuery, refUserCompanyId, refHazSpeciesKey, notIn = [] }) => {
    const where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "isTemp", type: "Boolean", operator: "=", value: false },
        { name: "refStatus.key", type: "String", operator: "=", value: "complete" },
        { name: "effectiveDate", type: "Date", operator: "<=", value: moment().format("YYYY-MM-DD") },
        { name: "expireDate", type: "Date", operator: ">=", value: moment().format("YYYY-MM-DD") },
        { name: "refOperation.key", type: "String", operator: "in", value: ["1", "4"] },
        { name: "refType.key", type: "String", operator: "in", value: ["2"] }
    ];
    if (refHazSpeciesKey) {
        where.push({ name: "refHazObject.refSpecies.key", type: "String", operator: "=", value: refHazSpeciesKey });
    }
    if (refUserCompanyId) {
        where.push({ name: "refUserCompany.id", type: "UUID", operator: "=", value: refUserCompanyId });
    }
    if (notIn?.length > 0) {
        where.push({ name: "id", type: "UUID", operator: "!in", value: notIn });
    }
    if (searchQuery) {
        where.push({ name: "approveCode", type: "String", operator: "like", value: searchQuery });
    }
    return store
        .dispatch("resource/v1/transaction/haz/search", {
            criteria: {
                isDistinct: true,
                select: ["*", "refOperation.*"],
                page: 0,
                size: 1000000,
                where,
                sort: [{ name: "approveCode", type: "DESC" }]
            }
        })
        .then(page => page.data);
};

export const callHazFull = ({ id }) => {
    return store
        .dispatch("resource/v1/transaction/haz/search", {
            criteria: {
                isDistinct: true,
                select: [
                    "*",
                    "refHazObject.*",
                    "refHazObject.refSpecies.*",
                    "refManufactureCountry.*",
                    "refSubStanceType.*",
                    "refType.*",
                    "refSubStanceTypeMain.*",
                    "refAnalysisAgency.*",
                    "refAnalysisMethod.*"
                ],
                page: 0,
                size: 1000000,
                where: [{ name: "id", type: "UUID", operator: "=", value: id }],
                children: [
                    {
                        name: "refHazObject.hazObjectCoordinates",
                        select: ["*", "refCoordinateCustoms.*", "refCoordinateCustoms.refUnit.*"],
                        page: 0,
                        size: 1000000
                    },
                    {
                        name: "mainSubStances",
                        select: ["*", "refSubStance.*", "refUnit.*"],
                        page: 0,
                        size: 1000000,
                        sort: [{ name: "createDate", type: "ASC" }]
                    },
                    {
                        name: "statuses",
                        asName: "lastStatus.forReceiveRemark",
                        select: ["**"],
                        page: 0,
                        size: 1,
                        where: [
                            {
                                name: "refStatus.key",
                                type: "String",
                                operator: "in",
                                value: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "complete"]
                            }
                        ],
                        sort: [{ name: "createDate", type: "DESC" }]
                    },
                    {
                        name: "products",
                        select: [
                            "*",
                            "refHaz.id",
                            "refHaz.version",
                            "refHaz.approveCode",
                            "refHaz.refUserCompany.id",
                            "refHaz.refUserCompany.version",
                            "refProduct.**",
                            "refProduct.refParent.*"
                        ],
                        page: 0,
                        size: 1000000
                    }
                ]
            }
        })
        .then(page => page.data[0]);
};

export const callInform = ({ searchQuery, userCompanyId, requestDocKeys, notIn = [], checkProductLength }) => {
    const where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "isTemp", type: "Boolean", operator: "=", value: false },
        { name: "refStatus.key", type: "String", operator: "=", value: "complete" },
        { name: "refUserCompany.id", type: "UUID", operator: "=", value: userCompanyId },
        { name: "products.refFreeSale.id", type: "UUID", operator: "=", value: null },
        { name: "products.refHazSpecies.key", type: "String", isNot: true, operator: "=", value: "1" },
        { name: "products.refHaz.refType.key", type: "String", isNot: true, operator: "=", value: "1" }
    ];
    if (requestDocKeys?.length > 0) {
        where.push({ name: "refRequestDoc.key", type: "String", operator: "in", value: requestDocKeys });
    }
    if (searchQuery) {
        where.push({ name: "approveCode", type: "String", operator: "like", value: searchQuery });
    }
    if (checkProductLength) {
        where.push({ name: "products", type: "Integer", function: "size", operator: ">", value: 0 });
    }
    if (notIn?.length > 0) {
        where.push({ name: "id", type: "UUID", operator: "!in", value: notIn });
    }
    return store
        .dispatch("resource/v1/transaction/inform/search", {
            criteria: {
                isDistinct: true,
                select: ["id", "approveCode", "refOperation.*"],
                page: 0,
                size: 1000000,
                where,
                sort: [{ name: "approveCode", type: "DESC" }],
                children: [
                    {
                        name: "products",
                        select: ["id"],
                        page: 0,
                        size: 1,
                        where: [
                            { name: "refHazSpecies.key", type: "String", operator: "!=", value: "1" },
                            { name: "refFreeSale.id", type: "UUID", operator: "=", value: null },
                            { name: "refHaz.refType.key", type: "String", operator: "in", value: ["2"] }
                        ]
                    }
                ]
            }
        })
        .then(page => page.data);
};

export const callInformFull = ({ id }) => {
    return store
        .dispatch("resource/v1/transaction/inform/search", {
            criteria: {
                select: ["**", "refUserCompany.refPersonType.*", "refUser.refPersonType.*"],
                page: 0,
                size: 1,
                where: [{ name: "id", type: "UUID", operator: "=", value: id }],
                children: [
                    {
                        name: "refUserCompany.addresses",
                        select: ["*"],
                        page: 0,
                        size: 1,
                        where: [{ name: "refAddressType.key", type: "String", operator: "=", value: "1" }]
                    },
                    {
                        name: "refUser.addresses",
                        select: ["*"],
                        page: 0,
                        size: 1,
                        where: [{ name: "refAddressType.key", type: "String", operator: "=", value: "1" }]
                    },
                    {
                        name: "products",
                        select: [
                            "**",
                            "refHazObject.refSpecies.*",
                            "refCoordinateCustoms.refUnit.*",
                            "refHaz.refManufactureCountry.*",
                            "refHazLicense.refQuantityUnit.*",
                            "refFreeSale.*",
                            "refHaz.refType.*",
                            "refOriginDestinationCountry.*"
                        ],
                        page: 0,
                        size: 1000000,
                        where: [
                            { name: "refHazSpecies.key", type: "String", operator: "!=", value: "1" },
                            { name: "refFreeSale.id", type: "UUID", operator: "=", value: null },
                            { name: "refHaz.refType.key", type: "String", operator: "in", value: ["2"] }
                        ],
                        sort: [{ name: "createDate", type: "ASC" }],
                        children: [
                            {
                                name: "refHaz.products",
                                select: ["*", "refProduct.**"],
                                page: 0,
                                size: 1000000,
                                sort: [{ name: "createDate", type: "ASC" }]
                            },
                            {
                                name: "refHazObject.hazObjectCoordinates",
                                select: ["*", "refCoordinateCustoms.*", "refCoordinateCustoms.refUnit.*"],
                                page: 0,
                                size: 1000000
                            },
                            {
                                name: "refHaz.mainSubStances",
                                select: ["*", "refSubStance.*", "refUnit.*"],
                                page: 0,
                                size: 1000000,
                                sort: [{ name: "createDate", type: "ASC" }]
                            }
                        ]
                    },
                    {
                        name: "statuses",
                        asName: "lastStatus.forReceiveRemark",
                        select: ["**"],
                        page: 0,
                        size: 1,
                        where: [
                            {
                                name: "refStatus.key",
                                type: "String",
                                operator: "in",
                                value: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "complete"]
                            }
                        ],
                        sort: [{ name: "createDate", type: "DESC" }]
                    }
                ]
            }
        })
        .then(page => page.data[0]);
};

const Address = defineAsyncComponent(() => import("../../../../../components/address/Address"));
const CardBorder = defineAsyncComponent(() => import("../../../../../components/card/CardBorder"));
const FreeSaleProductTable = defineAsyncComponent(() => import("./FreeSaleProductTable"));

export const createField = ({ props, data, key, isLoading, items }) => {
    const { viewOnly, menuContext } = props;
    const { useForm } = data;
    const { modelRef, initialModel } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const initModel = key ? lodash.get(initialModel, key) : initialModel;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            {
                key: `${prefix}refHaz`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                colProp: () => ({ xs: 24 }),
                formItemRender: () => <div class="text-bold text-16">{i18n.global.t("views.request.freeSale.tab2.cardHazTitle")}</div>
            },
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refHaz`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.freeSale.refHaz.approveCode"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refHaz,
                            "onUpdate:value": value => {
                                model.isSave = true;
                                model.refHaz = null;
                                model.refHazObject = null;
                                model.tradeNameTh = null;
                                model.tradeNameEn = null;
                                model.isSolid = null;
                                model.solid = null;
                                model.isLiquid = null;
                                model.liquid = null;
                                model.refSubStanceType = null;
                                model.manufacturer = null;
                                model.manufacturerEn = null;
                                model.refManufactureCountry = null;
                                model.ph = null;
                                model.refType = null;
                                model.toUse = null;
                                model.refSubStanceTypeMain = null;
                                model.refAnalysisAgency = null;
                                model.refAnalysisMethod = null;

                                lodash.remove(model.products, d => !d.id);
                                model.products.forEach(d => (d.isDelete = true));
                                model.refCountry = null;
                                model.refInformProduct = null;
                                model.freeSaleProducts = [];
                                model.refOperation = value.refOperation;
                                if (value) {
                                    callHazFull({
                                        id: value.id,
                                        refOperationKey: model.refOperation?.key
                                    }).then(haz => {
                                        model.refHaz = haz;
                                        model.freeSaleProducts.push({
                                            refHaz: haz
                                        });
                                        model.refHazObject = haz.refHazObject;
                                        model.tradeNameTh = haz.tradeNameTh;
                                        model.tradeNameEn = haz.tradeNameEn;
                                        model.isSolid = haz.isSolid;
                                        model.solid = haz.solid;
                                        model.isLiquid = haz.isLiquid;
                                        model.liquid = haz.liquid;
                                        model.refSubStanceType = haz.refSubStanceType;
                                        model.manufacturer = haz.manufacturer;
                                        model.refManufactureCountry = haz.refManufactureCountry;
                                        model.ph = haz.ph;
                                        model.refType = haz.refType;
                                        model.toUse = haz.toUse;
                                        model.refSubStanceTypeMain = haz.refSubStanceTypeMain;
                                        model.refAnalysisAgency = haz.refAnalysisAgency;
                                        model.refAnalysisMethod = haz.refAnalysisMethod;
                                        model.products = haz.products;
                                        model.products.forEach(d => {
                                            d.id = null;
                                            d.refReal = null;
                                        });
                                    });
                                }
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) =>
                                callHaz({
                                    searchQuery,
                                    refUserCompanyId: model.refUserCompany?.id,
                                    notIn: items
                                        .filter(d => d.isDelete !== true && d.refObjective.key === "1")
                                        .map(d => d.refHaz?.id)
                                        .filter(d => d)
                                }),
                            optLabel: "approveCode"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.approveCode`) }
            }),
            createFieldDate({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refHaz.lastStatus.forReceiveRemark.0.statusDatetime`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.freeSale.refHaz.approveDate"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refHaz?.lastStatus?.forReceiveRemark?.[0]?.statusDatetime
                                ? moment(model.refHaz?.lastStatus?.forReceiveRemark?.[0]?.statusDatetime).format("YYYY-MM-DD")
                                : null,
                            "onUpdate:value": value => (model.refHaz.lastStatus.forReceiveRemark[0].statusDatetime = value),
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            ...createFieldHaz({ props, data, key: `${key}`, isLoading }),
            {
                key: `${prefix}refInform`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                colProp: () => ({ xs: 24 }),
                formItemRender: () => <div class="text-bold text-16">{i18n.global.t("views.request.freeSale.tab2.cardInformTitle")}</div>
            },
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refInform`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.freeSale.refInform.approveCode"),
                inputProp: ({ field }) => {
                    return lodash.merge(
                        {
                            value: model.refInform,
                            "onUpdate:value": value => {
                                model.isSave = true;
                                model.refInform = null;
                                model.refInformProduct = null;
                                model.refCountry = null;
                                model.freeSaleProducts = [];
                                model.refOperation = value.refOperation;
                                if (value) {
                                    callInformFull({
                                        id: value.id
                                    }).then(inform => {
                                        model.refInform = inform;
                                        model.refCountry = inform.refOriginDestinationCountry;
                                        model.freeSaleProducts = inform.products
                                            .filter(item => item.refHazSpecies?.key !== "1")
                                            .filter(item => item.id === initModel?.refInformProduct?.id || !item.refFreeSale);
                                    });
                                }
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) =>
                                callInform({
                                    searchQuery,
                                    userCompanyId: model.refUserCompany.id,
                                    requestDocKeys: ["17"], //use only 17
                                    checkProductLength: true
                                }),
                            optLabel: "approveCode",
                            allowClear: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                    );
                },
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldDate({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refInform.lastStatus.forReceiveRemark.0.statusDatetime`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.freeSale.refInform.approveDate"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refInform?.lastStatus?.forReceiveRemark?.[0]?.statusDatetime
                                ? moment(model.refInform?.lastStatus?.forReceiveRemark?.[0]?.statusDatetime).format("YYYY-MM-DD")
                                : null,
                            "onUpdate:value": value => (model.refInform.lastStatus.forReceiveRemark[0].statusDatetime = value),
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            ...createFieldInform({ props, data, key: `${key}`, isLoading }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemRender: () => <div></div>,
            },
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}manufacturerEn`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.freeSale.manufacturerEn"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.manufacturerEn,
                            "onUpdate:value": value => (model.manufacturerEn = value),
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            {
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}addresses.0`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24 }, wrapperCol: { xs: 24 } }),
                inputRender: () => (
                    <>
                        <div className="text-bold text-16">{i18n.global.t("views.request.freeSale.addressEn")}</div>
                        <Address
                            menuContext={menuContext}
                            viewOnly={viewOnly}
                            dataProp={data}
                            dataKey={`${prefix}addresses.0`}
                            locale={[{ name: "En", suffix: false }]}
                            isLoading={isLoading.value}
                        ></Address>
                    </>
                )
            },
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemRender: () => <Divider></Divider>
            },
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24 }, wrapperCol: { xs: 24 } }),
                inputRender: () => {
                    const cardProp = lodash.merge(
                        {
                            title: i18n.global.t("views.request.freeSale.tab2.cardProductTitle")
                        },
                        conditionFormChecker({ props, data, executeKey: "cardProp", params: { componentKey: "ProductDetail" } })
                    );
                    const componentProp = lodash.merge(
                        {
                            menuContext: menuContext,
                            viewOnly: viewOnly,
                            dataProp: data,
                            itemsKey: `${prefix}freeSaleProducts`,
                            visiblePagination: false,
                            productsKey: model.refObjective?.key === "1" ? "refHaz" : "refInform"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { componentKey: "FreeSaleProductTable" } })
                    );
                    return () => {
                        model?.freeSaleProducts;
                        return !model?.freeSaleProducts?.length ? (
                            <span></span>
                        ) : (
                            <>
                                <CardBorder {...cardProp}>
                                    <FreeSaleProductTable {...componentProp}></FreeSaleProductTable>
                                </CardBorder>
                            </>
                        );
                    };
                }
            }
        ]
    });
};

export const createFieldHaz = ({ props, data, key, isLoading }) => {
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";

    return putField({
        data,
        fields: [
            createFieldTemplateBuilder({
                colProp: () => ({ xs: 24, md: 12 }),
                inputProp: () => ({
                    useForm: useForm,
                    fields: [
                        createFieldSelect({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                            key: `${prefix}refHazObject`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => `${i18n.global.t("model.haz.refHazObject")} (TH)`,
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refHazObject,
                                        "onUpdate:value": value => (model.refHazObject = value),
                                        disabled: true,
                                        list: callHazObject,
                                        optLabel: "nameTh"
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.nameTh`) }
                        }),
                        createFieldInput({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                            key: `${prefix}refHazObject.nameEn`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => `${i18n.global.t("model.haz.refHazObject")} (EN)`,
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refHazObject?.nameEn,
                                        "onUpdate:value": value => (model.refHazObject.nameEn = value),
                                        disabled: true
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                )
                        }),
                        createFieldInput({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                            key: `${prefix}refHazObject.refSpecies.value`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.hazObject.refSpecies"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model?.refHazObject?.refSpecies?.value,
                                        "onUpdate:value": value => (model.refHazObject.refSpecies.value = value),
                                        disabled: true
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                )
                        }),
                        createFieldSelect({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                            key: `${prefix}refSubStanceType`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.haz.refSubStanceType"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model?.refSubStanceType,
                                        "onUpdate:value": value => (model.refSubStanceType = value),
                                        disabled: true,
                                        list: callHazDetailSubStanceType,
                                        optLabel: "value"
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
                        }),
                        createFieldTemplateBuilder({
                            key: `${prefix}labelNature`,
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("views.request.hazInfo.nature"),
                            inputProp: () => ({
                                useForm: useForm,
                                fields: [
                                    createFieldCheckbox({
                                        visible: ({ field }) =>
                                            conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                                        key: `${prefix}isSolid`,
                                        colProp: () => ({ xs: 12 }),
                                        formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                                        label: () => i18n.global.t("model.haz.isSolid"),
                                        labelRender: () => "",
                                        inputProp: ({ field }) =>
                                            lodash.merge(
                                                {
                                                    checked: model?.isSolid,
                                                    "onUpdate:checked": checked => {
                                                        model.isSolid = checked;
                                                        if (checked) {
                                                            model.isLiquid = false;
                                                            model.liquid = null;
                                                        }
                                                    },
                                                    disabled: true,
                                                    text: () => i18n.global.t("model.haz.isSolid")
                                                },
                                                conditionFormChecker({ props, data, executeKey: "checkboxField", params: { field } })
                                            )
                                    }),
                                    createFieldInput({
                                        visible: ({ field }) =>
                                            conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                                        key: `${prefix}solid`,
                                        colProp: () => ({ xs: 12 }),
                                        formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                                        label: () => i18n.global.t("model.haz.solid"),
                                        labelRender: () => "",
                                        inputProp: ({ field }) =>
                                            lodash.merge(
                                                {
                                                    value: model?.solid,
                                                    "onUpdate:value": value => (model.solid = value),
                                                    disabled: true
                                                },
                                                conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                            )
                                    }),
                                    createFieldCheckbox({
                                        visible: ({ field }) =>
                                            conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                                        key: `${prefix}isLiquid`,
                                        colProp: () => ({ xs: 12 }),
                                        formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                                        label: () => i18n.global.t("model.haz.isLiquid"),
                                        labelRender: () => "",
                                        inputProp: ({ field }) =>
                                            lodash.merge(
                                                {
                                                    checked: model?.isLiquid,
                                                    "onUpdate:checked": checked => {
                                                        model.isLiquid = checked;
                                                        if (checked) {
                                                            model.isSolid = false;
                                                            model.solid = null;
                                                        }
                                                    },
                                                    disabled: true,
                                                    text: () => i18n.global.t("model.haz.isLiquid")
                                                },
                                                conditionFormChecker({ props, data, executeKey: "checkboxField", params: { field } })
                                            )
                                    }),
                                    createFieldInput({
                                        visible: ({ field }) =>
                                            conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                                        key: `${prefix}liquid`,
                                        colProp: () => ({ xs: 12 }),
                                        formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                                        label: () => i18n.global.t("model.haz.liquid"),
                                        labelRender: () => "",
                                        inputProp: ({ field }) =>
                                            lodash.merge(
                                                {
                                                    value: model?.liquid,
                                                    "onUpdate:value": value => (model.liquid = value),
                                                    disabled: true
                                                },
                                                conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                            )
                                    })
                                ],
                                skeleton: isLoading.value
                            })
                        }),
                        createFieldInput({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                            key: `${prefix}ph`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.haz.ph"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model?.ph,
                                        "onUpdate:value": value => (model.ph = value),
                                        disabled: true
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                )
                        })
                    ],
                    skeleton: isLoading.value
                })
            }),
            createFieldTemplateBuilder({
                colProp: () => ({ xs: 24, md: 12 }),
                inputProp: () => ({
                    useForm: useForm,
                    fields: [
                        createFieldInput({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                            key: `${prefix}tradeNameTh`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.haz.tradeNameTh"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model?.tradeNameTh,
                                        "onUpdate:value": value => (model.tradeNameTh = value),
                                        disabled: true
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                )
                        }),
                        createFieldInput({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                            key: `${prefix}tradeNameEn`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.haz.tradeNameEn"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.tradeNameEn,
                                        "onUpdate:value": value => (model.tradeNameEn = value),
                                        disabled: true
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                )
                        }),
                        createFieldInput({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                            key: `${prefix}manufacturer`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.haz.manufacturer"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.manufacturer,
                                        "onUpdate:value": value => (model.manufacturer = value),
                                        disabled: true
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                )
                        }),
                        createFieldSelect({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                            key: `${prefix}refManufactureCountry`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.haz.refManufactureCountry"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refManufactureCountry,
                                        "onUpdate:value": value => (model.refManufactureCountry = value),
                                        disabled: true,
                                        list: callCountry,
                                        renderLabel: ({ item }) => (
                                            <span>
                                                {item.nameEnS} : {item.nameTh}
                                            </span>
                                        )
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.nameTh`) }
                        })
                    ],
                    skeleton: isLoading.value
                })
            }),

            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refType`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                label: () => i18n.global.t("model.haz.refType"),
                inputProp: ({ field }) => {
                    let list = callHazType;
                    if (model.refOperation?.key === "4") {
                        list = ({ searchQuery }) => callHazType({ searchQuery }).then(items => items.filter(item => item.key === "2"));
                    }
                    return lodash.merge(
                        {
                            value: model.refType,
                            "onUpdate:value": value => (model.refType = value),
                            disabled: true,
                            list,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    );
                },
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}toUse`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                label: () => i18n.global.t("model.haz.toUse"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.toUse,
                            "onUpdate:value": value => (model.toUse = value),
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}products`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                label: () => i18n.global.t("views.request.hazInfo.toUse"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.products,
                            "onUpdate:value": value => (model.products = value),
                            disabled: true,
                            list: ({ searchQuery }) => callHazProductUse({ searchQuery }).then(items => items.map(item => ({ refProduct: item }))),
                            optLabel: "refProduct.value",
                            mode: "multiple",
                            optKey: "refProduct.id"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValueChildren: ({ record }) => record.refProduct?.value }
            }),

            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refSubStanceTypeMain`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                label: () => i18n.global.t("model.haz.refSubStanceTypeMain"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refSubStanceTypeMain,
                            "onUpdate:value": value => {
                                const oldValue = model.refSubStanceTypeMain;
                                model.refSubStanceTypeMain = value;
                                clearSubStanceMain({ modelRef, model });
                                if (
                                    (["micro"].includes(oldValue?.key) && !["micro"].includes(value?.key)) ||
                                    (!["micro"].includes(oldValue?.key) && ["micro"].includes(value?.key))
                                ) {
                                    model.mainSubStances.forEach(mainSubStance => {
                                        if (mainSubStance.refHaz?.refSubStance?.refType?.key !== "media") {
                                            mainSubStance.refHaz.refSubStance = null;
                                        }
                                    });
                                }
                                if (!["chemi"].includes(value?.key)) {
                                    model.refHaz.isTechnicalGrade = false;
                                }
                            },
                            disabled: true,
                            list: callHazSubStanceType,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refAnalysisAgency`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.haz.refAnalysisAgency"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refAnalysisAgency,
                            "onUpdate:value": value => (model.refAnalysisAgency = value),
                            disabled: true,
                            list: callDepartment,
                            renderLabel: ({ item }) => (
                                <div>
                                    {item.fullCode} : {item.nameTh}
                                </div>
                            ),
                            filterWhere: ({ value }) => [
                                { name: "fullCode", operator: "like", value },
                                { logic: "OR", name: "nameTh", operator: "like", value }
                            ],
                            treeDefaultExpandAll: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.nameTh`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refAnalysisMethod`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.haz.refAnalysisMethod"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refAnalysisMethod,
                            "onUpdate:value": value => (model.refAnalysisMethod = value),
                            disabled: true,
                            list: callAnalyticalMethod,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            })
        ]
    });
};

export const createFieldInform = ({ props, data, key /*, isLoading*/, items, importExportDateTitle, refOriginDestinationCountryTitle }) => {
    // const { viewOnly, menuContext } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldDate({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refInform.importExportDate`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => importExportDateTitle || `${i18n.global.t("views.request.informInfo.date", { text: model.refOperation?.value })}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: lodash.get(model, `refInform.importExportDate`),
                            "onUpdate:value": value => lodash.set(model, `refInform.importExportDate`, value),
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldSelect({
                visibleInput: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refInform.refTransportObjective`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.inform.refTransportObjective"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: lodash.get(model, `refInform.refTransportObjective`),
                            "onUpdate:value": value => lodash.set(model, `refInform.refTransportObjective`, value),
                            disabled: true,
                            list: callTransportObjective,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refInform.refTransportByWay`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.inform.refTransportByWay"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: lodash.get(model, `refInform.refTransportByWay`),
                            "onUpdate:value": value => {
                                lodash.set(model, `refInform.refTransportByWay`, value);
                                lodash.set(model, `refInform.refPassCustoms`, null);
                            },
                            disabled: true,
                            list: callTransportByWay,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refInform.containerNo`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.inform.containerNo"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: lodash.get(model, `refInform.containerNo`),
                            "onUpdate:value": value => lodash.set(model, `refInform.containerNo`, value),
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refInform.vehicleNo`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.inform.vehicleNo"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: lodash.get(model, `refInform.vehicleNo`),
                            "onUpdate:value": value => lodash.set(model, `refInform.vehicleNo`, value),
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refInform.refOriginDestinationCountry`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () =>
                    refOriginDestinationCountryTitle ||
                    `${i18n.global.t("views.request.informInfo.country", {
                        text:
                            model.refOperation?.key === "1"
                                ? i18n.global.t("views.request.informInfo.source")
                                : i18n.global.t("views.request.informInfo.desc")
                    })}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: lodash.get(model, `refInform.refOriginDestinationCountry`),
                            "onUpdate:value": value => lodash.set(model, `refInform.refOriginDestinationCountry`, value),
                            disabled: true,
                            list: callCountry,
                            renderLabel: ({ item }) => (
                                <span>
                                    {item.nameEnS} : {item.nameTh}
                                </span>
                            )
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.nameTh`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refInform.sealNo`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.inform.sealNo"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: lodash.get(model, `refInform.sealNo`),
                            "onUpdate:value": value => lodash.set(model, `refInform.sealNo`, value),
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTreeSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refInform.refExportCheckpoint`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.inform.refExportCheckpoint"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: lodash.get(model, `refInform.refExportCheckpoint`),
                            "onUpdate:value": value => lodash.set(model, `refInform.refExportCheckpoint`, value),
                            disabled: true,
                            list: callDepartment,
                            renderLabel: ({ item }) => (
                                <div>
                                    {item.fullCode} : {item.nameTh}
                                </div>
                            ),
                            filterWhere: ({ value }) => [
                                { name: "fullCode", operator: "like", value },
                                { logic: "OR", name: "nameTh", operator: "like", value }
                            ],
                            treeDefaultExpandAll: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTreeSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refInform.refImportCheckpoint`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t(`model.inform.refImportCheckpoint`),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: lodash.get(model, `refInform.refImportCheckpoint`),
                            "onUpdate:value": value => {
                                lodash.set(model, `refInform.refImportCheckpoint`, value);
                                lodash.set(model, `refInform.refPassCustoms`, null);
                            },
                            disabled: true,
                            list: callDepartment,
                            renderLabel: ({ item }) => (
                                <div>
                                    {item.fullCode} : {item.nameTh}
                                </div>
                            ),
                            filterWhere: ({ value }) => [
                                { name: "fullCode", operator: "like", value },
                                { logic: "OR", name: "nameTh", operator: "like", value }
                            ],
                            treeDefaultExpandAll: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refInform.refPassCustoms`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.inform.refPassCustoms"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: lodash.get(model, `refInform.refPassCustoms`),
                            "onUpdate:value": value => lodash.set(model, `refInform.refPassCustoms`, value),
                            disabled:
                                true ||
                                !lodash.get(model, `refInform.refImportCheckpoint.id`) ||
                                !lodash.get(model, `refInform.refTransportByWay.id`),
                            list: ({ searchQuery }) =>
                                callCustoms({
                                    searchQuery,
                                    refDepartmentId: lodash.get(model, `refInform.refImportCheckpoint.id`),
                                    refTransportByWayId: lodash.get(model, `refInform.refTransportByWay.id`)
                                }),
                            optLabel: "name"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refInformProduct.refHazObject.refSpecies.value`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.hazObject.refSpecies"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refInformProduct?.refHazObject?.refSpecies?.value,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                    )
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refInformProduct.refHazObject`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.informProduct.refHazObject"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refInformProduct?.refHazObject,
                            "onUpdate:value": value => {
                                model.refInform.isSave = true;
                                model.refInformProduct.refHazObject = value;
                                model.refCoordinateCustoms = null;
                            },
                            disabled: true,
                            list: ({ searchQuery }) =>
                                callHazObject({
                                    searchQuery,
                                    notIn: items
                                        .filter(d => d.isDelete !== true)
                                        .map(d => d.refHazObject?.id)
                                        .filter(d => d),
                                    species: ["02"].includes(data.useForm.modelRef.refRequestDoc?.key) ? [] : [model.refHazSpecies?.key]
                                }),
                            optLabel: "nameTh"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.nameTh`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refInform.refOriginDestinationCountry`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.informProduct.refOriginDestinationCountry"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refInformProduct?.refOriginDestinationCountry,
                            "onUpdate:value": value => {
                                model.refInformProduct.isSave = true;
                                model.refInformProduct.refOriginDestinationCountry = value;
                            },
                            disabled: true,
                            list: callCountry,
                            renderLabel: ({ item }) => (
                                <span>
                                    {item.nameEnS} : {item.nameTh}
                                </span>
                            )
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.nameTh`) }
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refInform.formula`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.informProduct.formula"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refInformProduct?.formula,
                            "onUpdate:value": value => {
                                model.refInformProduct.isSave = true;
                                model.refInformProduct.formula = value;
                            },
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refInform.manufacturer`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.informProduct.manufacturer"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refInformProduct?.manufacturer,
                            "onUpdate:value": value => {
                                model.refInformProduct.isSave = true;
                                model.refInformProduct.manufacturer = value;
                            },
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refInform.storageName`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.informProduct.storageName"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refInformProduct?.storageName,
                            "onUpdate:value": value => {
                                model.refInformProduct.isSave = true;
                                model.refInformProduct.storageName = value;
                            },
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                    )
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refInform.refCoordinateCustoms`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.informProduct.refCoordinateCustoms"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refInformProduct?.refCoordinateCustoms,
                            "onUpdate:value": value => {
                                model.refInformProduct.isSave = true;
                                model.refInformProduct.refCoordinateCustoms = value;
                            },
                            disabled: true || !model.refHazObject,
                            list: ({ searchQuery }) =>
                                filter({
                                    list: model.refHazObject?.hazObjectCoordinates.map(d => d.refCoordinateCustoms),
                                    where: [{ name: "name", type: "String", operator: "like", value: searchQuery }],
                                    sort: [{ name: "name", type: "ASC" }]
                                }),
                            renderLabel: ({ item }) => (
                                <div>
                                    {item.name} {item.code}/{item.refUnit?.value}
                                </div>
                            )
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.name`) }
            })
        ]
    });
};
